import { browser } from '$app/environment';
import { init, register, addMessages } from 'svelte-i18n';
import localeDe from './locales/de/index.js';

export const defaultLocale = 'de';
const _supportedLocales = ['de', 'en'] as const;
export type SupportedLocale = (typeof _supportedLocales)[number];
// @ts-ignore
export const supportedLocales: SupportedLocale[] = _supportedLocales.sort();
export const localeEntryGenerator = (): { language: string }[] => {
    return supportedLocales.map((locale: SupportedLocale) => ({ language: locale }));
};

export function initI18n(initialLocale?: SupportedLocale) {
    addMessages('de', localeDe as any);
    register('en', () => import('./locales/en/index.js'));

    init({
        fallbackLocale: defaultLocale,
        initialLocale: initialLocale ? initialLocale : browser ? window.navigator.language : defaultLocale
    });
}
